import { Component, Injectable } from '@angular/core';
import { OfbizField, RemoteFormData } from '../ofbiz-form-model';
import { OfbizCellLinkedListComponent } from '../ofbiz-cell-linked-list/ofbiz-cell-linked-list.component';
import { OfbizCellInternalLinkComponent } from '../ofbiz-cell-internal-link/ofbiz-cell-internal-link.component';
import { OfbizCellDisplayLinkComponent } from '../ofbiz-cell-display-link/ofbiz-cell-display-link.component';
import { OfbizCellDisplayComponent } from '../ofbiz-cell-display/ofbiz-cell-display.component';
import { OfbizCellDropdownComponent } from '../ofbiz-cell-dropdown/ofbiz-cell-dropdown.component';
import { BehaviorSubject } from 'rxjs';
import { SmartTableDatePickerComponent } from '../smart-table-date-picker/smart-table-date-picker.component';
import { OfbizCustomLinkEditorComponent } from '../ofbiz-custom-link-editor/ofbiz-custom-link-editor.component';
import { OfbizCellDropdownEditorComponent } from '../ofbiz-cell-dropdown-editor/ofbiz-cell-dropdown-editor.component';
import { OfbizCellHyperLinkComponent } from '../ofbiz-cell-hyper-link/ofbiz-cell-hyper-link.component';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizCellImageComponent } from '../ofbiz-cell-image/ofbiz-cell-image.component';
import { OfbizCellCheckboxComponent } from '../ofbiz-cell-checkbox/ofbiz-cell-checkbox.component';
import { OfbizCellInputComponent } from '../ofbiz-cell-input/ofbiz-cell-input.component';
import { OfbizCellSequenceComponent } from '../ofbiz-cell-sequence/ofbiz-cell-sequence.component';
import { OfbizCellCompositeComponent } from '../ofbiz-cell-composite/ofbiz-cell-composite.component';

@Injectable({
  providedIn: 'root'
})
export class ColumnConfigService {
  hyperlinkCellSelected = new BehaviorSubject<any>(null);
  dropDownOptions = new BehaviorSubject<any[]>([]);
  baseUrl: string;

  constructor(configServices: ConfigurationService) {
    this.baseUrl = configServices.baseUrl;
  }
  /**
   * Uses the field to create a column object which can be used in the settings of a smart table
   * Field types are used to determine the type of column to be created
   * @param field The field for which the column is to be created
   * @param findFields
   * @param listOptions
   * @returns column object which can be used in the settings of a smart table
   */
  createColumn(field: any, findFields: any[], listOptions: any): any {
    console.log({ TrackConfigureColumn: { field: field, listOptions: listOptions } });
    console.log("Creating Column for Field", field.name, field.type, field.title);
    const labelColumn = listOptions?.labelColumn ? listOptions.labelColumn : undefined;
    const column = {};
    const type = this.getType(field);
    console.log({ TrackColumnType: { originalType: field.type, normalisedType: type } })
    column["title"] = field.title;
    column["type"] = type;
    // console.log({TrackConfigureColumn:{title:column["title"],type:column["type"]}});
    /*     if(field.type == "hyperlink"){
          column["valuePrepareFunction"] = (cell,row) => {return cell}
        } */
    /**
     * If the field has a description, set the valuePrepareFunction to return the description
     */
    if (type !== "custom") {
      if (field.description) {
        column["valuePrepareFunction"] = (value) => {
          return field.description;
        }
      }
      if (field.entryName) {
        column["valuePrepareFunction"] = (cell, row) => {
          const entryName = field.entryName;
          // console.log("Row",row);
          return row[entryName];
        }
      }
      if (type == "image") {
        console.log("Doing Image Type")
        const renderedComponent = this.getRenderComponent(field);
        column["renderComponent"] = renderedComponent;
        column["onComponentInitFunction"] = (instance) => {
          instance.field = field;
          instance.baseUrl = this.baseUrl;
        }
      }
    } else if (type == "custom") {
      console.log("Track Custom ColumnType: " + field.type);
      console.log("Custom Field", field);
      const columnComponent: any = this.getRenderComponent(field);
      // columnComponent.
      // column["renderComponent"] = this.getRenderComponent(field);
      column["renderComponent"] = columnComponent;
      column["type"] = "custom";
      if (field.type === "hyperlink" || field.type === "HYPERLINK") {
        console.log("TrackColumnType HYPERLINK: " + field.type);
        // console.log("Field before Click",field)
        // column["componentInitFunction"] = columnComponent.componentInit;
        column["componentInitFunction"] = (instance, cell) => {
          console.log(instance, cell);
          instance.field = field;
          instance.cell = cell;
          instance.cellHyperlinkSelected.subscribe(data => {
            this.hyperlinkCellSelected.next(data)
          })
        };
        /* column["valuePrepareFunction"] = (value) => {
          return value;
        }; */
      } else {
        console.log("TrackColumnType Other Custom NOT HYPERLINK: " + field.type);
      }
      if (field.type == "display-entity" || field.type == "DISPLAY_ENTITY") {
        if (field.parameterList || field.hyperlink) {
          column["componentInitFunction"] = (instance, cell) => {
            instance.field = field;
            instance.cell = cell;
            instance.cellHyperlinkSelected.subscribe(data => {
              this.setHyperlinkCell({ field: field, rowData: data, labelColumn: labelColumn })
            })
          };
        } else {
          column["componentInitFunction"] = (instance, cell) => {
            instance.field = field;
            instance.cell = cell;
          };
          column["valuePrepareFunction"] = (value) => {
            console.log("Value in Display Entity Column", value);
            if (findFields != undefined && findFields.length > 0) {
              return this.getDisplayValue(value, field, findFields);
            } else {
              return value
            }
          }
        }

      }
      if (field.type == "DROP_DOWN" || field.type == "drop-down") {
        column["componentInitFunction"] = (instance, cell) => {
          instance.field = field;
          instance.cell = cell;
        };
        column["valuePrepareFunction"] = (value) => {
          const fieldOptions: any[] = field["options"];
          const currentOption = fieldOptions.find(option => option["key"] == value);
          if (currentOption) {
            return currentOption["description"]
          } else {
            return value
          }
        }
      }
      if (field.type == "image" || field.type == "IMAGE") {
        console.log("Doing Image Type")
        column["componentInitFunction"] = (instance, cell) => {
          instance.field = field;
          instance.cell = cell;
          instance.baseUrl = this.baseUrl;
        }
      }
      if (field.type == "input" || field.type == "INPUT" || field.type == "Input") {
        column["componentInitFunction"] = (instance, cell) => {
          instance.field = field;
          instance.cell = cell;
          instance.baseUrl = this.baseUrl;
          instance.editable = this.getEditable(field);
        }
      }
      if (field.type == "SEQUENCE" || field.type == "sequence") {
        column["componentInitFunction"] = (instance, cell) => {
          instance.field = field;
          instance.cell = cell;
          instance.baseUrl = this.baseUrl;
          instance.editable = this.getEditable(field);
        }
      }
      if (field.type == "COMPOSITE" || field.type == "composite") {
        column["componentInitFunction"] = (instance, cell) => {
          instance.field = field;
          instance.baseUrl = this.baseUrl;
          instance.cell = cell;
          instance.editable = this.getEditable(field);
        }
      }

    }
    column["editable"] = this.getEditable(field);
    column["editor"] = this.getEditor(field);
    column["filter"] = false;
    column["sort"] = true;
    // console.log({columnDetails:{field:field.name,column:column}});
    console.log(column)
    return column
  }
  /**
   *
   * @param field The field for which the type is to be returned
   * @returns html,custom, text(default)
   */
  getType(field): string {
    let type = "";
    console.log(field["type"], field["name"]);
    switch (field["type"]) {
      case "datetime":
      case "DATE_TIME":
        type = "html"
        break;
      case "hyperlink":
      case "HYPERLINK":
      case "drop-down":
      case "DROP_DOWN":
      case "SEQUENCE":
      case "sequence":
      case "COMPOSITE":
        type = "custom"
        break;
      case undefined:
        type = "text"
        break;
      case "display-entity":
      case "DISPLAY_ENTITY":
        type = "custom"
        break;
      case "IMAGE":
        type = "custom";
        break;
      case "check":
      case "CHECK":
        type = "custom";
        break;
      case "INPUT":
      case "Input":
      case "input":
        type = "custom";
        break;
      default:
        type = "text"
        break;
    }
    return type
  }
  /**
   * Function to determine and set the component used for the renderComponent property of a column
   * @param field The field containing the type which is used to decide which component to return
   * @returns the component to be used to render the cell;
   */
  getRenderComponent(field: OfbizField): Component {
    let component = null;
    switch (field["type"]) {
      case "hyperlink":
      case "HYPERLINK":
        console.log({ TrackRenderComponent: { Component: "OfbizListServices", field: field } })
        if (field.event != undefined && field.event == "list" || field.formData?.link != undefined) {
          component = OfbizCellLinkedListComponent;
        } else {
          console.log("Its a Cell Hyperlink")
          component = OfbizCellHyperLinkComponent
        }

        break;
      case "display-entity":
      case "DISPLAY_ENTITY":
        if (field.parameterList || field.hyperlink) {
          console.log({ TrackRenderComponent: { Component: "OfbizListServices", field: field } })
          if (field.hyperlink && field.hyperlink.targetType != undefined) {
            component = OfbizCellInternalLinkComponent;
            console.log("It's a OfbizCellInternalLinkComponent", field["name"])
          } else {
            component = OfbizCellDisplayLinkComponent
            console.log("It's a OfbizCellDisplayLinkComponent", field["name"])
          }
        } else {
          component = OfbizCellDisplayComponent
          console.log("It's a OfbizCellDisplayComponent", field["name"])
        }
        break;
      case "drop-down":
      case "DROP_DOWN":
        console.log("Setting OfbizCellDropdownComponent")
        component = OfbizCellDropdownComponent
        break;
      case "image":
      case "IMAGE":
        component = OfbizCellImageComponent;
        break;
      case "check":
      case "CHECK":
        component = OfbizCellCheckboxComponent;
        break;
      case "input":
      case "INPUT":
      case "Input":
        component = OfbizCellInputComponent;
        break;
      case "sequence":
      case "SEQUENCE":
        component = OfbizCellSequenceComponent;
        break;
      case "COMPOSITE":
      case "composite":
        component = OfbizCellCompositeComponent;
        break;
      default:
        break;
    }
    return component
  }
  /**
   * Function used to set values for the  cell hyperlink
   * Values emitted are event,type, data(formData and endPoint)
   * @param data - field and row data
   */
  setHyperlinkCell(data: any): void {
    console.log("RowData in setHyperlinkCell", data)
    /* console.log("RowData in setHyperlinkCell",data);
    console.log("ParameterData in setHyperlinkCell",data["rowData"]["parameterMap"]);
    console.log({TrackHyperLinkCell:{data:data}}) */
    const rowData = data["rowData"];
    const field = data["field"];
    const labelColumn = data.labelColumn != undefined ? data.labelColumn : field.name;
    let hyperLink: any = {};
    if (field.type == "hyperlink" || field.type == "HYPERLINK") {
      console.log({ HyperLink: field });
      hyperLink = { "target": field["target"], "event": field["event"], "parameters": {}, "formData": field["formData"], "appContext": field["appContext"] };
      console.log({ HyperLinkAfter: hyperLink });
    } else if (field.type == "display-entity" || field.type == "DISPLAY_ENTITY") {
      if (field.hyperlink) {
        hyperLink = {
          "targetType": field.hyperlink["targetType"],
          "target": field.hyperlink["target"],
          "name": field.name,
          "rowData": rowData,
          "event": "link",
          "formData": field.hyperlink["remoteFormData"]["formData"],
        }
      } else {
        hyperLink = { "target": field["entityName"], "event": field["event"], "parameters": {}, "formData": field["formData"] };
      }

    }

    if (rowData["parameterMaps"] != undefined && rowData["parameterMaps"].length > 0) {
      const parameterMaps: any[] = rowData["parameterMaps"];
      let parameterMap = parameterMaps.find(element => element.fieldName == field.name);
      if (parameterMap != undefined) {
        // console.log({parameterMapFromRowData:parameterMap});
        hyperLink.parameters = parameterMap["parameterMap"];
      } else {
        parameterMap = parameterMaps[0];
        hyperLink.parameters = parameterMap["parameterMap"];
      }
    } else {
      const parameterList: any[] = field["parameterList"];
      console.log({ "parameterList": parameterList });
      parameterList.forEach(parameterData => {
        const parameter = {};
        // parameter["name"] = parameterData["name"];
        if (data["field"].type == "hyperlink" || data["field"].type == "HYPERLINK") {
          if (rowData[parameterData["fromField"]["original"]]) {
            parameter[parameterData["name"]] = rowData[parameterData["fromField"]["original"]];
            // parameter["value"] = rowData[parameterData["fromField"]["original"]]
          }
        } else if (field.type == "display-entity" || field.type == "DISPLAY_ENTITY") {
          parameter[parameterData["name"]] = rowData[parameterData["name"]];
        }
        // hyperLink.parameters = {...hyperLink.parameters,parameter}
        Object.assign(hyperLink.parameters, parameter);
      })
    }
    console.log({ hyperLinkAfterParameters: hyperLink });
    /**
     * Routime to replace ${} templates in links
     * Check if hyperLink has link value in the formData
     * And check if it contains variables enclosed in ${}
     * if variable exist in the parameters object, replace ${variable} with actual value
     */
    if (hyperLink.formData.link && hyperLink.parameters) {
      console.log("FormDataLink", hyperLink.formData.link, "Parameters", hyperLink.parameters)
      if (this.containsDollarBracketVariable(hyperLink.formData.link)) {
        hyperLink.formData.link = this.replaceDollarBracketVariable(hyperLink.formData.link, hyperLink.parameters);
      }
    }

    const event = hyperLink["event"];
    let remoteFormData = {};
    if (event != "link") {
      console.log("The Link", hyperLink["formData"].link);
      const remoteFormDataHolder: RemoteFormData = {
        formData: {
          "formName": hyperLink["formData"].formName,
          "formLocation": hyperLink["formData"].formLocation,
          "listType": hyperLink["formData"].listType || "form",
          "link": hyperLink["formData"].link || null,
        },
        endPoint: hyperLink["formData"].endPoint,
        parameters: hyperLink.parameters,
        "appContext": hyperLink["appContext"] || "",
      }
      remoteFormData = remoteFormDataHolder;
    }

    let returnValue = {};
    switch (event) {
      case "view":
        returnValue = { "event": "view", "type": hyperLink["formData"]["formName"], "data": remoteFormData, "label": rowData[labelColumn] };
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "list":
        returnValue = { "event": "list", "type": hyperLink["formData"]["formName"], "data": remoteFormData, "label": rowData[labelColumn] };
        console.log({ returnValue: returnValue });
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "edit":
        returnValue = { "event": "edit", "type": hyperLink["formData"]["formName"], "data": remoteFormData, "label": rowData[labelColumn] };
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "delete":
        returnValue = { "event": "delete", "type": hyperLink["formData"]["formName"], "data": remoteFormData, "label": rowData[labelColumn] }
        // console.log({returnValue:returnValue});
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "add":
        returnValue = { "event": "add", "type": hyperLink["formData"]["formName"], "data": remoteFormData, "label": rowData[labelColumn] }
        // console.log({returnValue:returnValue});
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "link":
        returnValue = hyperLink;
        console.log({ linkReturnValue: returnValue });
        this.hyperlinkCellSelected.next(returnValue);
        break;
      default:
        break;
    }

  }
  /**
   * Function used to set the editable property of a column
   * @param field
   * @returns boolean - true, field is editable. false, field is not editable
   */
  getEditable(field: OfbizField): boolean {
    // console.log({"type":field.type});
    let editable = false;
    if (field.readonly == false) {
      return editable = true
    } else {
      switch (field.type) {
        case "text":
        case "TEXT":
          editable = true
          break;
        case "datetime":
        case "DATE_TIME":
          editable = true
          break;
        case "DROP_DOWN":
          this.createDropDownOptions(field);
          editable = true;
          break
        default:
          editable = false
          break;
      }
    }
  }

  getDisplayValue(value: string, field: OfbizField, findFields: any[]): string {
    console.log({ "TrackDisplayValue": { value: value, field: field.name, findFieldsLength: findFields.length } });
    let description = null;
    if (findFields != undefined) {
      const findField = findFields.find(element => element.name == field.name);
      if (findField) {
        if (findField.allOptionValues) {
          const findValue = findField.allOptionValues.find(element => element.key == value);
          if (findValue) {
            description = findValue.description;
          }
        }
      }
    }
    if (description == null && value != null) {
      description = value;
    }
    // console.log({"GettingDisplayValue":description,field:field.name});
    return description;
  }

  createDropDownOptions(field): void {
    // console.log({TrackDropDown:"Setting Stuff"})
    const fieldOptions = { name: field.name, options: field.options }
    this.dropDownOptions.next(this.dropDownOptions.getValue().concat([fieldOptions]));
  }

  getEditor(field): any {
    let editor = {};
    switch (field["type"]) {
      case "datetime":
      case "DATE_TIME":
        editor = { "type": "custom", "component": SmartTableDatePickerComponent }
        break;
      case "hyperlink":
      case "HYPERLINK":
        editor = { "type": "custom", "component": OfbizCustomLinkEditorComponent }
        break;
      case "DROP_DOWN":
        editor = { "type": "custom", "component": OfbizCellDropdownEditorComponent }
        break;
      default:
        editor = { "type": "text" }
        // console.log({TrackEditor:field.name,"type":field["type"]});
        break;
    }
    // ({Editor:{field:field.name,editor:editor}});
    return editor;
  }

  containsDollarBracketVariable(str: string): boolean {
    const regex = /\${(.*?)}/;
    return regex.test(str);
  }

  replaceDollarBracketVariable(str: string, variables: { [key: string]: string }): string {
    return str.replace(/\${(.*?)}/g, (match, p1) => {
      return variables[p1] || '';
    });
  }
}
